import React from 'react';
import { FieldCheckbox } from '../../../components';
import css from '../SelectMultipleFilter/SelectMultipleFilter.module.css';

function ConditionFilter({ id, name, className }) {
  return (
    <fieldset className={className}>
      <ul className={css.list}>
        <li className={css.item}>
          <FieldCheckbox id={`${id}.new`} name={name} label="New football boots" value="new" />
        </li>
        <li className={css.item}>
          <FieldCheckbox id={`${id}.used`} name={name} label="Used football boots" value="used" />
        </li>
      </ul>
    </fieldset>
  );
}

export default ConditionFilter;
